export interface BatchTrcContentDataUpdateRequest {
  startNumFrom: string
  startNumTo: string
  convertHyoukiToFull: boolean
  contentDataFile: string
  memo: string
  batchType: string
}

export function BatchTrcContentDataUpdateRequestToJSON(
  value: BatchTrcContentDataUpdateRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    content_data_file: value.contentDataFile,
    memo: value.memo,
    batch_type: value.batchType
  }
}
